module.exports = __webpack_public_path__ + "img/img_jiqi@2x.162146b5.png";